import React from "react";

import { useTitle } from "../../../../helpers/useTitle";

import { Subtitle, Title } from "../../common";
import { ColorTypes, useBusinessWidgetButtons } from "../../hooks";
import { isButtonDefine } from "../../hooks/utils";
import { CustomMainCta, SecondaryCta } from "../components";

export const DefaultHero: React.FC<{}> = () => {
  const { title, description } = useTitle();
  const { primaryButton, secondaryButton } = useBusinessWidgetButtons();

  return (
    <>
      <Title colorType={ColorTypes.Title}>{title}</Title>
      <Subtitle colorType={ColorTypes.Subtitle}>{description}</Subtitle>
      {isButtonDefine(primaryButton) && <CustomMainCta {...primaryButton} color={"primary"} />}
      {isButtonDefine(secondaryButton) && <SecondaryCta {...secondaryButton} color={"secondary"} />}
    </>
  );
};
